import React from 'react';
import { scaleLinear } from 'd3-scale';

const ComponentCounter = props => {
    const scale = scaleLinear()
        .domain([0, props.target.range])
        .range([0, 100]);

    // convert values from between 0-props.range to 0-100
    const currentX = scale(props.current);
    const targetStart = scale(props.target.min);
    const targetEnd = scale(props.target.max);
    const targetWidth = targetEnd - targetStart;

    let className = 'ComponentCounter-danger';
    if (
        props.current >= props.target.min &&
        props.current <= props.target.max
    ) {
        className = 'ComponentCounter-good';
    }

    return (
        <svg
            className={className}
            viewBox="0 0 100 100"
            preserveAspectRatio="none">
            <rect className="background" x="0" y="0" width="100" height="100" />
            <rect
                className="target"
                x={targetStart}
                y="0"
                width={targetWidth}
                height="100"
            />
            <rect
                className="current"
                x="0"
                y="25"
                width={currentX}
                height="50"
            />
        </svg>
    );
};

export default ComponentCounter;
